import { Fragment, h } from "preact";
import { Link } from "react-router-dom";

import i18n from "../i18n";
import { classNames } from "../helpers";

import Icon from "./Icon.jsx";
import { useEffect } from "preact/hooks";

export default function TaskModalHeader({ onClose, sticky, task }) {
  useEffect(() => {
    document.title = i18n.t("page_title", {
      title: i18n.t(`tasks.${task.id}.title`),
    });
  });
  return (
    <Fragment>
      <div
        class={classNames(
          "task-modal__header task-modal-header",
          sticky && "task-modal-header--sticky"
        )}
      >
        <div class="task-modal-header__inner">
          {onClose ? (
            <Link class="task-modal-header__closer" onClick={onClose}>
              <Icon alt={i18n.t("actions.back_to_tasklist")}>close</Icon>
            </Link>
          ) : (
            <Link to="/tasks" class="task-modal-header__closer">
              <Icon alt={i18n.t("actions.back_to_tasklist")}>close</Icon>
            </Link>
          )}
          <Link to="/tasks">
            <img
              src="/images/logo_icon.svg"
              width="48"
              height="48"
              class="hide-on-med-and-down"
            />
          </Link>
        </div>
      </div>
      {sticky && <div class="task-modal-header--sticky-substitute"></div>}
    </Fragment>
  );
}
